import {matchRoutes, useLocation} from 'react-router-dom';
import type {RouteObject} from 'react-router-dom';
import pages, {Page} from '../pages';

const routeObjects: RouteObject[] = pages.map(page => ({
    path: page.path,
    handle: page
}));

/**
 * Returns the declarative Page entry (from pages.ts) matching the current
 * location, so layout chrome can react to page-level flags like fullBleed.
 */
export function usePageConfig(): Page | undefined {
    const location = useLocation();
    const matches = matchRoutes(routeObjects, location);
    if (!matches || matches.length === 0) {
        return undefined;
    }
    return matches[matches.length - 1].route.handle as Page;
}

export default usePageConfig;
